module.exports = __webpack_public_path__ + "static/media/ohne.d12a0c5f.png";